<div class="col-12">
  <div class="row">
    <h2 class="col-12 titleBookk"><b>{{ 'BILANCARBONNE.TITLE' | translate }}</b></h2>

  </div>
  <ng-template [ngIf]="loadCurrenMonth" [ngIfElse]="loadCurrenMonthLoading">
    <div class="row justify-content-center margin-block">
      <h3 class="col-12 bold">{{ 'BILANCARBONNE.MONTH.TITLE' | translate }}</h3>

      <div class="col-lg-3 col-12 mb-sm-3 servicecarbone">
        <div class="round-img-large box-shadow eco-info ">
          <h5 class="mt-4">
            <img style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Charge.svg" />
          </h5>
          
          <label> {{ 'BILANCARBONNE.MONTH.DISTANCE' | translate }} </label>
          <h6 class="mt-2"> {{currentMonth.total_km}} Km</h6>
        </div>

      </div>
      <div class="col-lg-3 col-12 ">
        <div class="round-img-large box-shadow eco-info">
          <h5  class="mt-4">
            <img style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Feuille.svg" />
          </h5>

          <label>{{ 'BILANCARBONNE.MONTH.CO2' | translate }}</label>
          <h6 class="mt-2"> {{currentMonth.total_bilan}} g</h6>
      
        </div>
      </div>


    </div>


    <div class="row justify-content-center margin-block">
      <div class="col-12 col-lg-8">
        <mat-card class="row  box-shadow ">

          <mat-card-content>
            <h3 class="col-12 bold">{{ 'BILANCARBONNE.MONTH.TABLETITLE' | translate }}</h3>
            <div class="col-12 table-responsive">
              <!-- <mat-form-field>
                    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrer">
                  </mat-form-field> -->

              <table class="col-12 " mat-table [dataSource]="currentBilanDataSource" matSort>
                <!-- Progress Column -->
                <ng-container matColumnDef="startdate">
                  <th class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.MONTH.TABLE1' | translate }}</div></th>
                  <td class="oneline" mat-cell *matCellDef="let row"> {{row.startdate | date:"dd/MM/yyyy HH:mm"}} </td>
                </ng-container>

                <!-- Name Column -->

                <!-- Color Column -->
                <ng-container matColumnDef="duration">
                  <th class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.MONTH.TABLE2' | translate }}</div></th>
                  <td class="oneline" mat-cell *matCellDef="let row"> {{row.duration}} min</td>
                </ng-container>
                <ng-container matColumnDef="km">
                  <th class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.MONTH.TABLE3' | translate }}</div></th>
                  <td class="oneline" mat-cell *matCellDef="let row"> {{row.km}} km</td>
                </ng-container>
                <ng-container matColumnDef="bilan">
                  <th  class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.MONTH.TABLE4' | translate }}</div></th>
                  <td class="oneline" mat-cell *matCellDef="let row" class="eco-data"> {{(row.bilan / 1000) | number}} kg</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </ng-template>


  <ng-template #loadCurrenMonthLoading>
    <div class="row justify-content-center mt-4">
      <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
    </div>
  </ng-template>

  <ng-template [ngIf]="allLoad" [ngIfElse]="selectedAllLoading">
    <div class="row justify-content-center ">
        <h3 class="col-12 margin-block bold">{{ 'BILANCARBONNE.YEAR.TABLETITLE' | translate }}</h3>

        <div class="col-12 col-lg-8">
            <mat-card class="row  box-shadow ">
      
              <mat-card-content>
                <div class="row">
                  <div class="col-2" style="text-align: center">
                    <button style="text-align: center" mat-icon-button (click)="previousMonth();">
                      <mat-icon>fast_rewind</mat-icon>
                    </button>
                  </div>
      
                  <h3 class="col-md-8 col-7 bold">{{DisplayMonth[monthWanted]}} {{yearWanted}}</h3>
                  <div class="col-2" style="text-align: center">
                    <button style="text-align: center" class="mr-4" mat-icon-button (click)="nextMonth();">
                      <mat-icon>fast_forward</mat-icon>
                    </button>
                  </div>
                </div>


                <div class="col-12 table-responsive ">
                  <!-- <mat-form-field>
                          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrer">
                        </mat-form-field> -->
      
                  <table class="col-12 " mat-table [dataSource]="currentBilanWantedDataSource" matSort>
                    <!-- Progress Column -->
                    <ng-container matColumnDef="startdate">
                      <th class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.YEAR.TABLE1' | translate }}</div></th>
                      <td class="oneline" mat-cell *matCellDef="let row"> {{row.startdate | date:"dd/MM/yyyy HH:mm"}} </td>
                    </ng-container>
      
                    <!-- Name Column -->
      
                    <!-- Color Column -->
                    <ng-container matColumnDef="duration">
                      <th class="oneline " mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.YEAR.TABLE2' | translate }}</div></th>
                      <td class="oneline" mat-cell *matCellDef="let row"> {{row.duration}} min</td>
                    </ng-container>
                    <ng-container matColumnDef="km">
                      <th class="oneline" mat-header-cell *matHeaderCellDef><div class="mr-3">{{ 'BILANCARBONNE.YEAR.TABLE3' | translate }}</div></th>
                      <td class="oneline" mat-cell *matCellDef="let row"> {{row.km}} km</td>
                    </ng-container>
                    <ng-container  matColumnDef="bilan">
                      <th  class="oneline" mat-header-cell *matHeaderCellDef><div class="">{{ 'BILANCARBONNE.YEAR.TABLE4' | translate }}</div></th>
                      <td class="oneline" mat-cell *matCellDef="let row" class="eco-data"> {{(row.bilan / 1000) | number}} kg</td>
                    </ng-container>
      
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                    </tr>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
    </div>
    <div class="row justify-content-center  margin-block">
      <h3 class="col-12 margin-block bold">{{ 'BILANCARBONNE.YEAR.TITLE' | translate }}</h3>
      <div class="col-md-3 col-12 mb-sm-3 servicecarbone">
        <div class="round-img-large box-shadow eco-info">
          <h5 class="mt-4">
            <img style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Charge.svg" />
          </h5>
          
          <label> {{ 'BILANCARBONNE.YEAR.DISTANCE' | translate }} </label>
          <h6 class="mt-2"> {{completeEco?.total_km}} km</h6>
        </div>

      </div>

      <div class="col-md-3 col-12">
        <div class="round-img-large box-shadow eco-info">
          <h5 class="mt-4">
            <img style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Feuille.svg" />
          </h5>

          <label>{{ 'BILANCARBONNE.YEAR.CO2' | translate }}</label>
          <h6 class="mt-2">  {{completeEco?.total_bilan}} g</h6>
          
        </div>
      </div>

    </div>

  </ng-template>
  <ng-template #selectedAllLoading>
    
  </ng-template>


</div>
